// import React, { useEffect } from 'react';
// import { useHistory } from 'react-router-dom';

// const PptRedirect = () => {
    
// //   useEffect(() => {
// //     window.location.replace('https://docs.google.com/presentation/d/14c0uRdiXH5AHGH1tIHqb4R-T1fZPbeMHnPq3SxJ2OgM/edit?slide=id.gcb9a0b074_1_0#slide=id.gcb9a0b074_1_0');
// //   }, []);
  
//   return (
//     <div style={{ 
//       width: '100%', 
//       height: '100vh', 
//       display: 'flex', 
//       justifyContent: 'center', 
//       alignItems: 'center' 
//     }}>
//       <iframe
//         src="https://docs.google.com/presentation/d/14c0uRdiXH5AHGH1tIHqb4R-T1fZPbeMHnPq3SxJ2OgM/embed?start=true&loop=true&delayms=3000"
//         frameBorder="0"
//         width="100%"
//         height="100%"
//         allowFullScreen
//         title="Embedded Google Slides Presentation"
//       ></iframe>
//     </div>
//   );

//   return null;
// };

// export default PptRedirect;


import React from 'react';

const PptRedirect = () => {
  return (
    <div style={styles.pageWrapper}>
      <div style={styles.iframeContainer}>
        <iframe
          // src="https://docs.google.com/presentation/d/14c0uRdiXH5AHGH1tIHqb4R-T1fZPbeMHnPq3SxJ2OgM/embed"
          // src="https://docs.google.com/presentation/d/1wkYqpmRmdL9nr7pac0xgNk99LcHpLvWG79L4e9xxDWc/embed"
          // src="https://docs.google.com/presentation/d/1oM70AdmMWxnvZhkLyl_xQXjUXRywBY6x2b1g0k3j4c/embed"
          src="https://docs.google.com/presentation/d/1oM70AdmMWxnvZhkLyl_xQXjUXRywBY6x/embed"
          frameBorder="0"
          width="100%"
          height="100%"
          allowFullScreen
          title="Embedded Google Slides Presentation"
        ></iframe>
      </div>
    </div>
  );
};

const styles = {
  pageWrapper: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
    boxSizing: 'border-box',
  },
  iframeContainer: {
    width: '100%',
    maxWidth: '1200px',
    height: '100%',
    maxHeight: '800px',
    borderRadius: '12px',
    border: '2px solid rgba(255, 255, 255, 0.8)',
    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.2)',
    backgroundColor: 'rgba(255, 255, 255, 0.3)', // Glassy effect
    backdropFilter: 'blur(10px)',
    overflow: 'hidden',
  },
};

export default PptRedirect;
